var _radialGradient, _clipPath, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _path, _g, _path2, _ellipse, _path3, _ellipse2, _path4, _ellipse3, _path5, _ellipse4, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtistpalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 60.676,
    cy: 20.768,
    gradientTransform: "matrix(0 1 -.6564 0 74.288 -39.907)",
    gradientUnits: "userSpaceOnUse",
    r: 106.44
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcc80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    stopColor: "#ffcb7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4879,
    stopColor: "#ffc774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6526,
    stopColor: "#ffc166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8012,
    stopColor: "#ffb850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#ffad35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa726"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m117.5 56.14c4.21-3.85 14.28-23.01-4.45-40.17-6.3-5.78-20.55-11.97-36.64-11.97-24.41 0-55.53 12.41-67.63 40.2-17.43 40 15.48 79.8 55.84 79.8 18.59 0 38.95-11.46 47.23-23.08.52-.73 1.09-1.42 1.63-2.13 2.04-2.65 6.01-10.02-7.34-15.64-5.93-2.5-6.66-8.26-5.93-11.13 2.19-8.67 9.65-8.89 17.29-15.88zm-29.87 43.38c-6.47 2.2-13.17-.24-14.97-5.46-1.8-5.21 1.98-11.22 8.45-13.42s13.17.24 14.97 5.46c1.8 5.21-1.98 11.22-8.45 13.42z"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 59.167,
    cy: 13.833,
    gradientTransform: "matrix(0 1 -.7798 0 69.954 -45.333)",
    gradientUnits: "userSpaceOnUse",
    r: 17.099
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef5350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3459,
    stopColor: "#e94b49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8869,
    stopColor: "#d73534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d32f2f"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 31.522,
    cy: 35.116,
    gradientTransform: "matrix(0 1 -.7798 0 58.905 3.5937)",
    gradientUnits: "userSpaceOnUse",
    r: 20.387
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42a5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2859,
    stopColor: "#3b9def"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7328,
    stopColor: "#2787de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976d2"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 24.833,
    cy: 65.667,
    gradientTransform: "matrix(0 1 -.7798 0 76.04 40.833)",
    gradientUnits: "userSpaceOnUse",
    r: 21.006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeb3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#ffeb3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6129,
    stopColor: "#fee238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8995,
    stopColor: "#fcca30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbc02d"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 45,
    cy: 93.5,
    gradientTransform: "matrix(0 1 -.7798 0 117.91 48.5)",
    gradientUnits: "userSpaceOnUse",
    r: 17.099
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8bc34a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3459,
    stopColor: "#83bb46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8869,
    stopColor: "#6da53b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#689f38"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m117.5 56.14c4.21-3.85 14.28-23.01-4.45-40.17-6.3-5.78-20.55-11.97-36.64-11.97-24.41 0-55.53 12.41-67.63 40.2-17.43 40 15.48 79.8 55.84 79.8 18.59 0 38.95-11.46 47.23-23.08.52-.73 1.09-1.42 1.63-2.13 2.04-2.65 6.01-10.02-7.34-15.64-5.93-2.5-6.66-8.26-5.93-11.13 2.19-8.67 9.65-8.89 17.29-15.88zm-29.87 43.38c-6.47 2.2-13.17-.24-14.97-5.46-1.8-5.21 1.98-11.22 8.45-13.42s13.17.24 14.97 5.46c1.8 5.21-1.98 11.22-8.45 13.42z",
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffa726"
  }, /*#__PURE__*/React.createElement("ellipse", {
    clipPath: "url(#b)",
    cx: 28.28,
    cy: 96.32,
    opacity: 0.2,
    rx: 16.05,
    ry: 4.02,
    transform: "matrix(.773 -.6344 .6344 .773 -54.686 39.806)"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m11.6 101.76s24.05-24.13 32.07-20.11-20.04 28.15-20.04 28.15h-4.01l4.01 4.02s36.07-28.15 32.07-40.22-44.56 22.71-47.25 24.28z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m1.51 87.52s33.55-26.8 66.59-29.98c0 0 10.51-2.34 8.18 5.69-2.34 8.04-14.35 36.51-44.23 56.1l-3.5-2.51s51.07-35.67 34.55-51.92c0 0-1.84-3.01-12.68 1.34s-47.41 28.98-47.41 28.98l-1.5-7.7z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m-3.32 78.52s24.17-17.06 51.62-26.1 38.51-26.72 38.51-26.72.2 16.03-42.81 32.89-43.63 25.28-43.63 25.28l-3.69-5.35z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m65.55 3.48s-38.92 46.04-59.2 35.35l-3.69 7.19s34.21 4.32 68-42.96l-5.11.42z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m.43 56.8s29.29-4.11 46.7-15.83 26.21-32.67 53.46-31.65l5.53 2.26s-17.82-3.91-32.57 13.57-18.43 18.91-31.54 23.64-44.45 11.71-44.45 11.71l2.87-3.7z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m118.73 20.26s-20.99 11.96-27.47 20.03c0 0 25.4-12.74 32.92-11.18z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m124.23 35.19s-39.26 14.23-48.73 39.88-22.11 33.43-24.99 34.87c-2.87 1.44-18.67 15.27-18.96 16.43l11.78 2.31s26.42-22.48 29.29-38.04 17.99-37.27 55.63-53.72z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m82.16 95.93s-10.63 25.36-30.16 41.21c0 0 22.4-10.38 36.48-38.91z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m106.95 83.37s-8.36 34.02-23.47 42.43c0 0 20.9-1.83 30.54-43.53z",
    opacity: 0.2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m76.41 7c14.71 0 28.55 5.63 34.62 11.19 6.62 6.07 9.98 12.9 9.97 20.31-.01 7.78-3.79 13.86-5.52 15.43-2.56 2.34-5.09 3.85-7.55 5.31-4.59 2.74-8.93 5.33-10.62 12.05-1.04 4.14.14 11.45 7.68 14.63 4.36 1.84 6.97 3.97 7.55 6.18.52 1.96-.67 3.89-1.42 4.86-.17.22-.34.43-.51.65-.39.5-.8 1.01-1.19 1.57-7.49 10.49-26.74 21.82-44.8 21.82-19.6 0-38.4-10.1-49.05-26.36-9.73-14.86-11.2-32.8-4.04-49.24 5.28-12.12 14.91-22.17 27.86-29.07 11.29-6.02 24.44-9.33 37.02-9.33m6.42 96.33c1.94 0 3.88-.33 5.77-.97 4.31-1.46 7.81-4.43 9.63-8.13 1.45-2.96 1.69-6.2.69-9.11-1.74-5.03-6.84-8.29-13-8.29-1.94 0-3.88.33-5.77.97-4.31 1.46-7.81 4.43-9.63 8.13-1.45 2.96-1.69 6.2-.69 9.11 1.74 5.04 6.84 8.29 13 8.29m-6.42-99.33c-24.41 0-55.53 12.41-67.63 40.2-17.43 40 15.48 79.8 55.84 79.8 18.59 0 38.95-11.46 47.23-23.08.52-.73 1.09-1.42 1.63-2.13 2.04-2.65 6.01-10.02-7.34-15.64-5.93-2.5-6.66-8.26-5.93-11.13 2.18-8.67 9.64-8.9 17.28-15.88 4.21-3.85 14.28-23.01-4.45-40.17-6.29-5.78-20.54-11.97-36.63-11.97zm6.42 96.33c-4.7 0-8.81-2.35-10.17-6.26-1.8-5.21 1.98-11.22 8.45-13.42 1.61-.55 3.24-.81 4.8-.81 4.7 0 8.81 2.35 10.17 6.27 1.8 5.21-1.98 11.22-8.45 13.42-1.61.54-3.24.8-4.8.8z",
    fill: "#424242",
    opacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.54,
    cy: 23.78,
    fill: "#c62828",
    rx: 12.82,
    ry: 10.28,
    transform: "matrix(.9546 -.2979 .2979 .9546 -4.2463 19.712)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m72.86 18.74c1.61 5.27-2.47 11.21-9.13 13.26s-13.37-.56-14.98-5.83 2.47-11.21 9.13-13.26 13.36.56 14.98 5.83z",
    fill: "url(#c)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.87,
    cy: 45.37,
    fill: "#1565c0",
    rx: 12.94,
    ry: 10.34,
    transform: "matrix(.9546 -.2979 .2979 .9546 -11.931 12.447)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m45.56 40.15c1.66 5.41-2.54 11.49-9.36 13.6s-13.7-.57-15.36-5.98 2.54-11.49 9.36-13.6 13.7.57 15.36 5.98z",
    fill: "url(#d)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.45,
    cy: 75.28,
    fill: "#f9a825",
    rx: 13.3,
    ry: 10.67,
    transform: "matrix(.9546 -.2979 .2979 .9546 -21.184 11.599)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m38.52 70.58c1.61 5.27-2.47 11.21-9.13 13.26s-13.37-.56-14.98-5.83 2.47-11.21 9.13-13.26c6.66-2.06 13.37.55 14.98 5.83z",
    fill: "url(#e)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.29,
    cy: 103.12,
    fill: "#558b2f",
    rx: 12.68,
    ry: 10.34,
    transform: "matrix(.9545 -.2983 .2983 .9545 -28.562 19.098)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m58.69 98.41c1.61 5.27-2.47 11.21-9.13 13.26s-13.37-.56-14.98-5.83 2.47-11.21 9.13-13.26 13.37.56 14.98 5.83z",
    fill: "url(#f)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistpalette);
export default __webpack_public_path__ + "static/media/artistpalette.076cec208c57ade6ed1772778e9903ac.svg";
export { ForwardRef as ReactComponent };